import React, { Suspense, lazy } from "react";
import Navbar from "./components/Navbar/Navbar";
import Badge from "./components/Badge/Badge";
import Statement from "./components/Statement/Statement";
import Hero from "./components/Hero/Hero";
import Footer from "./components/Footer/Footer";
import "./App.css";
import OpenBlog from "./components/OpenBlog/OpenBlog";

// Lazy load components that are below the fold
const Projects = lazy(() => import("./components/Projects/Projects"));
const Experiences = lazy(() => import("./components/Experiences/Experiences"));
const Badges = lazy(() => import("./components/Badges/Badges"));
const CVDownload = lazy(() => import("./components/CVDownload/CVDownload"));
const BlogPosts = lazy(() => import("./components/BlogPosts/BlogPosts"));

function App() {
  const params = new URLSearchParams(window.location.search);
  const loadOnly = params.get("loadonly");
  const cv = params.get("cv");

  if (loadOnly) {
    return (
      <div className="App">
        <Suspense fallback={<div>Loading...</div>}>
          {loadOnly === "blogposts" ? <BlogPosts /> : null}
          {loadOnly === "projects" ? <Projects /> : null}
          {loadOnly === "experiences" ? <Experiences /> : null}
          {loadOnly === "badges" ? <Badges /> : null}
          {loadOnly === "cvdownload" ? <CVDownload /> : null}
          {loadOnly === "hero" ? <Hero /> : null}
          {loadOnly === "badge" ? <Badge /> : null}
          {loadOnly === "statement" ? <Statement /> : null}
        </Suspense>
      </div>
    );
  } else {
    return (
      <div className="App">
        <Navbar />
        <main>
          <Hero />
          <Suspense fallback={<div>Loading...</div>}>
            <Projects />
            <Experiences />
            <BlogPosts />
            {/* <Badges /> */}
          </Suspense>
        </main>
        <Footer />
        {cv ? (
          <Suspense fallback={<div>Loading...</div>}>
            <CVDownload />
          </Suspense>
        ) : null}
        <OpenBlog />
      </div>
    );
  }
}

export default App;
